import React from 'react';
import styled from 'styled-components';
import {
  AuctionFilledIcon,
  BidIcon,
  Button,
  TinyTitleRegular
} from '@kvdbil/components';
import { useTranslation } from '~/Locale';
import { ProcessedAuction } from '../../interfaces/ProcessedAuction';

const buttonHeight = '2.5rem';

const Container = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  gap: 2rem;
  position: absolute;
  bottom: calc((${buttonHeight} / 2) * -1);
  width: 100%;
`;

const IconInfoWrapper = styled.div`
  display: flex;
  align-items: center;
  align-self: center;
  border: ${({ theme }) => `1px solid ${theme.colors.grayscaleToned.light5}`};
  font-size: 13px;
  font-weight: ${({ theme }) => theme.typography.fontBaseBoldWeight};
  color: ${({ theme }) => theme.colors.grayscaleToned.dark3};
  border-radius: 5rem;
  background-color: ${({ theme }) => theme.colors.background.light};
  z-index: 1;

  margin-left: -1rem;
  margin-right: -1rem;
  height: 4rem;
  min-height: 4rem;

  justify-content: space-between;
  max-width: 540px;
  height: ${buttonHeight};
  min-height: ${buttonHeight};
`;

const IconInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;

  text-transform: uppercase;
  padding: 0.5rem 2rem;

  & svg {
    font-size: 1rem;
  }

  & p {
    font-size: 0.75rem;
  }
`;

const BiddingGuideButton = styled(Button)`
  height: ${buttonHeight};
  font-size: 0.75rem;
  z-index: 1;
`;

interface Props {
  auction: ProcessedAuction;
  handleGuideClick: React.MouseEventHandler<HTMLButtonElement>;
}
const BiddingInformation = ({ auction, handleGuideClick }: Props) => {
  const { t } = useTranslation();
  const numberOfBids = auction?.bids?.length ?? 0;

  return (
    <Container>
      <IconInfoWrapper>
        <IconInfo>
          <BidIcon />
          <TinyTitleRegular>{`${numberOfBids} ${
            numberOfBids === 1 ? t('Bid') : t('Bids')
          }`}</TinyTitleRegular>
        </IconInfo>
      </IconInfoWrapper>

      <BiddingGuideButton
        prefixIcon={<AuctionFilledIcon />}
        variant="solid"
        color="secondary"
        onClick={handleGuideClick}
        size="small"
      >
        {t('Bidding guide')}
      </BiddingGuideButton>
    </Container>
  );
};

export default BiddingInformation;
